"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfServiceModal = void 0;
var react_1 = __importDefault(require("react"));
require("./TermsOfServiceModal.scss");
var Modal_1 = require("@app/components/layout/Modal");
var ModalContent_1 = require("@app/components/layout/ModalContent");
var TermsOfServiceModal = function (props) { return (react_1.default.createElement(Modal_1.Modal, __assign({}, props),
    react_1.default.createElement(ModalContent_1.ModalContent, { title: "Terms of Service", onCloseClick: props.onClose },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "tos-content", dangerouslySetInnerHTML: { __html: process.env.TOS_HTML } }),
            react_1.default.createElement("hr", null),
            !props.hideButtons &&
                react_1.default.createElement("div", { className: "columns" },
                    react_1.default.createElement("div", { className: "column is-2" }),
                    react_1.default.createElement("div", { className: "column is-3" },
                        react_1.default.createElement("button", { type: "button", className: "button is-light is-fullwidth", onClick: props.onDecline }, "Decline")),
                    react_1.default.createElement("div", { className: "column is-5" },
                        react_1.default.createElement("button", { type: "button", className: "button is-primary is-fullwidth", onClick: props.onAccept }, "Accept")),
                    react_1.default.createElement("div", { className: "column is-2" })))))); };
exports.TermsOfServiceModal = TermsOfServiceModal;
